import { _ as r } from "../internals/export.js";
import { a } from "../internals/array-fill.js";
import { a as o } from "../internals/add-to-unscopables.js";
r({
  target: "Array",
  proto: !0
}, {
  fill: a
}), o("fill");